<template>
    <v-hover v-slot="{ hover }">
        <v-card
            class="br-10 mx-auto"
            width="215"
            elevation="0"
        >
            <div>
                <v-card-title class="catalogue-card-discount-wrapper">
                    <v-chip
                        v-if="discountPercent > 0"
                        class="main--yellow"
                        text-color="white"
                        small
                    >{{ $t('discount') }}&nbsp;{{ discountPercent.toFixed(2) }}&percnt;</v-chip>
                </v-card-title>
                <div class="product-actions">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                fab
                                text
                                icon
                                class="icon-action-btn"
                                @click="authActionHandle({type: 'favorites'})"
                            >
                                <v-icon color="orange lighten-2">{{favoritesIcon}}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('favorites') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                fab
                                text
                                icon
                                class="icon-action-btn"
                                @click="addToCompare(product.id)"
                            >
                                <v-img
                                    contain
                                    :src="comparedIcon(product.id)"
                                    :width="comparedIconSizes.width"
                                    :height="comparedIconSizes.height"
                                ></v-img>
                            </v-btn>
                        </template>
                        <span>{{ $t('compare') }}</span>
                    </v-tooltip>
                </div>
                <div>
                    <router-link :to="productLink">

                        <v-img
                            :aspect-ratio="1"
                            :src="getImageThumbSrc(product.images)"
                            :alt="`image-${product.id}`"
                            class="rounded-t-lg"
                        >
                            <v-fade-transition duration="3000">
                                <v-overlay
                                    v-if="hover"
                                    absolute
                                    color="grey"
                                ></v-overlay>
                            </v-fade-transition>
                        </v-img>
                    </router-link>
                </div>
            </div>
            <v-card-text
                class="px-3 px-sm-4 pt-1"
            >
                <div class="py-1">
                    <router-link
                        :to="productLink"
                        class="subtitle-1 text-truncate black--text d-block" :class="{'text-decoration-underline' : hover }"
                    >
                        {{product.productName}}
                    </router-link>
                </div>
                <div
                    v-if="product.seller"
                    class="grey--text text--lighten-1 caption text-truncate"
                >
                    <span v-if="product.seller.companyName">{{product.seller.companyName}}</span>
                    <span v-if="!product.seller.companyName">{{product.seller.firstName}} {{product.seller.lastName}}</span>
                </div>
                <div>
                    <span  :class="['pa-0', existenceColor]" class="caption">{{ existenceLable }}</span>
                </div>
                <div class="py-1">
                    <div v-if="isPriceSpecified" class="d-flex flex-wrap">
                        <div :class="discountPercent > 0 ? 'red--text' : 'black--text'" class="font-weight-medium mr-auto">
                            <span>{{ productPriceCurrency }}&nbsp;</span>
                            <span>{{ productPriceUnoWithDiscount }}</span>
                            <span>/{{ product.pack.unitName }}&nbsp;</span>
                        </div>
                        <div v-if="discountPercent > 0" class="text-decoration-line-through grey--text">
                            <small>{{ productPriceCurrency }}&nbsp;</small>
                            <small>{{ productPriceUno }}</small>
                            <small>/{{ product.pack.unitName }}</small>
                        </div>
                    </div>
                    <div v-else>
                        <span>{{ $t('priceNotSpecified') }}</span>
                    </div>
                </div>
                <policies-dialog
                    :seller-id="product.seller.id"
                    :seller-name="sellerTitle"
                    :product-policies="product.policies"
                ></policies-dialog>
            </v-card-text>
            <v-divider class="mx-2"></v-divider>
            <v-card-text class="d-flex px-0 justify-space-around align-center">
                <div>
                    <seller-dialog
                        :isOpen="sellerMessageOpen"
                        :product="product"
                        @close="sellerMessageOpen = false"
                    ></seller-dialog>
                    <add-to-basket-dialog
                        :product="product"
                        :is-open="openAddToBasketDialog"
                        @close="openAddToBasketDialog = false"
                    ></add-to-basket-dialog>

                    <v-btn
                        v-if="!isPriceSpecified"
                        color="main--yellow white--text"
                        dark
                        depressed
                        @click="authActionHandle({ type: 'knowPrice' })"
                    >
                        <span class="text-body-2">{{ $t('knowPrice') }}</span>
                    </v-btn>
                    <v-btn
                        id="open-add-basket-btn"
                        v-else-if="!inBasket"
                        color="main--yellow white--text"
                        dark
                        depressed
                        :disabled="!product.available"
                        @click="openAddDialog"
                    >
                        <span class="text-body-2">{{ $t('buy') }}</span>
                    </v-btn>
                    <v-btn
                        v-else
                        color="main--yellow white--text"
                        depressed
                        class="px-4"
                        :to="{ name:'Basket'}"
                    >
                        <span class="text-body-2">{{ $t(cartLabel) }}</span>
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
import AddToBasketDialog from "../../dialogs/AddToBasketDialog";
import PoliciesDialog from "../../../../views/front/basket/v-2/PoliciesDialog";
import SellersTable from '../sellers-table';
import ActionAccess from '../../../../app-front/mixins/ActionAccess';
import AddToBasket from '../../../../app-front/mixins/AddToBasket';
import Favorites from '../../../../app-front/mixins/Favorites';
import GeneralFilters from '../../../../app-front/mixins/FiltersGeneral';
import NoLoginBasket from "../../../mixins/NoLoginBasket";
import ProductsCompare from '../../../mixins/ProductsCompare';
import SellerDialog from '../../dialogs/ProductSellerDialog';
import Thumbs from '../../../../app-front/mixins/ThumbsProducts';
import BasketService from '../../../../app-front/services/api/BasketService';
import ProductService from '../../../../app-front/services/api/ProductService';
import { getPercentNumber } from '../../../../utils';

import './general-card.scss'
export default {
    name: "GeneralCard",
    props: ['product', 'filterKey','productData'],
    mixins:[
        ActionAccess,
        AddToBasket,
        Favorites,
        GeneralFilters,
        NoLoginBasket,
        ProductsCompare,
        Thumbs,
    ],
    components: {
        AddToBasketDialog,
        PoliciesDialog,
        SellersTable,
        SellerDialog,
    },
    data(){
        return {
            loadingSellers: false,
            sellersShow: false,
            sellersTableData: {
                headers: [],
                body: []
            },
            overlay: false,
            openAddToBasketDialog: false,
            priceUno: null,
            productRate: {
                productId: this.product.id,
                value: null,
                total: null,
            },
            sellerMessageOpen: false,
        }
    },
    computed: {
        inBasket() {
            return (this.isBasket(this.product.id) || this.isInNoLoginBasket(this.product.id));
        },
        basketName() {
            return this.isBasket(this.product.id)? this.$t('alreadyInBasket') : this.$t('toBasket');
        },
        componentSystemValue() {
            return this.product.id;
        },
        discountPercent() {
            return this.product.price.discountPercent;
        },
        existenceLable() {
            switch (this.product.available) {
                case 0: return this.$t('notAvailable');
                case 1: return this.$t('inStock');
                case 2: return this.$t('lowLevel');
            }
        },
        existenceColor() {
            switch (this.product.available) {
                case 0: return 'red--text';
                case 1: return 'teal--text';
                case 2: return 'orange--text text--lighten-2';
            }
        },
        productFilterKey() {
            return this.filterKey || 'category';
        },
        productPack() {
            return this.product.pack;
        },
        isPriceSpecified() {
            return !!this.productPrice;
        },
        feedbackLink(){
            return this.getProductLink(true);
        },
        productLink(){
            return this.getProductLink();
        },
        productPrice() {
            const currency = this.$store.state.appCurrency;
            return this.product.price[currency];
        },
        productPriceUno() {
            return this.productPrice.toFixed(2) || this.$t('contractual');
        },
        productPriceUnoWithDiscount() {
            const price = getPercentNumber(this.productPrice, this.discountPercent);
            return price.toFixed(2) || this.$t('contractual');
        },
        productPriceCurrency() {
            let currencySymbol;

            this.$store.getters.currencies.forEach(item => {
                if(item.name == this.$store.getters.appCurrency) {
                    currencySymbol = item.symbol;
                }
            })

            return currencySymbol;
        },
        minimumOrder() {
            if (this.product.pack.minValue > 0) {
                return this.product.pack.minValue * this.product.pack.value;
            } else {
                return this.product.pack.value;
            }

        },
        cartIcon() {
            return this.isBasket(this.product.id) ? 'shopping_cart' : 'add_shopping_cart';
        },
        favoritesIcon() {
            return this.isFavorite(this.product.id) ? 'favorite' : 'favorite_border';
        },
        cartLabel() {
            return this.inBasket ? 'alreadyInBasket' : 'buy';
        },

        sellerTitle() {
            if (!this.product.seller) return '';

            return this.product.seller.companyName || `${this.product.seller.lastName} ${this.product.seller.firstName}`
        },
    },
    methods: {
        authSuccessActionHandle(data) {
            switch(data.type) {
                case 'favorites' : this.actionFavorites(); break;
                case 'cart' : this.actionCart(); break;
                case 'knowPrice' : this.sellerMessageOpen = true; break;
            }
        },
        actionCart(){
            const product = {
                id: this.componentSystemValue,
                quantity: 1
            };
            BasketService.updateList([product])
                .then(res => {
                    this.$store.commit('setBasket', res.data);
                })
                .catch(err => {
                    console.log(err)
                });
        },
        actionFavorites() {
            this.$emit('snack-bar', this.componentSystemValue);
            this.addFavorite(this.componentSystemValue);
        },

        getSellersFilters() {
            const params = {};
            params[this.filtersGeneral.productSystemName.systemName] = this.product.productSystemName;

            return {...params, ...this.$store.state.filters[this.productFilterKey]};
        },
        getImageSrc(images) {
            if (!images.length) {
                return '/images/default-product.png';
            }
            return images[0];
        },
        getProductLink(feedback = false) {
            const link = {
                name: 'product',
                params: {
                    parentCategory: this.product.category.parentSystemName.toString(),
                    category: this.product.category.systemName.toString(),
                    sysNameWithId: `${this.product.productSystemName}-${this.product.id}`
                }
            }
            if(feedback) {
                link.query = { tab: 'feedback'}
            }
            return link;
        },
        getRating() {
            ProductService.getProductRate(this.id)
                .then(res => {
                    this.productRate = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        noLoginAction(data) {
            if (data.type == 'cart') {
                this.addToNoLoginBasket(this.product.id)
            }
        },
        openAddDialog(){
            this.openAddToBasketDialog = true;
            //this.authActionHandle({type: 'cart'})
        },
        priceMessage(product) {
            this.$emit('price-message', product)
        },
        ratingChange(value, id) {
            const params = {
                productId: id,
                value: value,
            };
            ProductService.setProductRate(params)
                .then(res => {
                    this.productRate = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        sellerMessage(product) {
            this.$emit('seller-message', product)
        },
        setSellersTable() {
            if(this.sellersTableData.headers.length && this.sellersTableData.body.length) {
                return false;
            }

            this.loadingSellers = true;
            const filters = this.getSellersFilters();

            ProductService.getDistributorsTable(filters)
                .then(res => {
                    this.sellersTableData = res.data;
                    this.loadingSellers = false;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        showSellersTable() {
            this.sellersShow = !this.sellersShow;
            this.setSellersTable();
        },

    },
    created() {
        this.productRate = this.product.rate
    }
}
</script>

<style scoped>

</style>
